import _ from 'lodash';

export const groupsTopHeaders = [
  { id: 'SG', name: '영업목표', val: 'sg', colSpan: 3 }, //SALES GOAL
  { id: 'TG', name: '세금계산서 실적', val: 'tg', colSpan: 3 }, //Tax results
  { id: 'CP', name: '협업이익/비용', val: 'cp', colSpan: 2 }, //collaborative profits
  { id: 'FSP', name: '최종매출이익', val: 'fsp', rowSpan: 2 }, //Final Sales Profits
  { id: 'SME', name: '판매관리비', val: 'sme', rowSpan: 2 }, //sales management expenses
  { id: 'BP', name: '영업이익', val: 'bp', rowSpan: 2 }, //business profits
  { id: 'SP', name: '영업이익율', val: 'sp', rowSpan: 2 }, //sales profits
];

export const sgHeaders = [
  { id: 'sales', name: '매출액' },
  { id: 'profitPrice', name: '매출이익' },
  { id: 'salesPrice', name: '영업이익' },
];

export const tgHeaders = [
  { id: 'sales', name: '매출액' },
  { id: 'purchase', name: '매입액' },
  { id: 'profitPrice', name: '매출이익' },
];

export const cpHeaders = [
  { id: 'cp', name: '협업이익' },
  { id: 'cc', name: '협업비용' },
];

export const billsSubHeaders = [
  { id: 'sales', name: '매출액' },
  { id: 'purchaseCost', name: '매입원가' },
  { id: 'profitPrice', name: '매출이익' },
];

export const hqData = [
  {
    id: '1',
    name: '기술지원본부',
    rowSpan: 1,
  },
  {
    id: '2',
    name: '전략사업본부',
    rowSpan: 1,
  },
  {
    id: '3',
    name: 'SI사업본부',
    rowSpan: 1,
  },
  {
    id: 'total',
    name: '합계',
    rowSpan: 1,
  },
];
export const teamData = [
  {
    id: '1',
    name: '인프라영업본부',
    rowSpan: 5,
    children: [
      { id: '1-1', name: '고객영업1팀' },
      { id: '1-2', name: '고객영업2팀' },
      { id: '1-3', name: '고객영업3팀' },
      { id: '1-4', name: '고객영업4팀' },
      {
        id: 'subTotal',
        name: '소계',
      },
    ],
  },
  {
    id: '2',
    name: '채널영업본부',
    rowSpan: 2,
    children: [
      { id: '2-1', name: '채널영업팀' },
      {
        id: 'subTotal',
        name: '소계',
      },
    ],
  },
  {
    id: '3',
    name: 'NI영업본부',
    rowSpan: 2,
    children: [
      { id: '2-1', name: 'NI영업팀' },
      {
        id: 'subTotal',
        name: '소계',
      },
    ],
  },
  {
    id: 'total',
    name: '합계',
    rowSpan: 1,
    children: [{ id: 'total', name: '합계' }],
  },
];
export const teamEmpData = [
  {
    id: '1',
    name: '전략사업본부',
    rowSpan: 9,
    children: [
      {
        id: '1-1',
        name: '전략사업1팀',
        rowSpan: 3,
        children: [
          { id: '1-1-1', name: '김인종 부장' },
          { id: '1-1-2', name: '양진섭 차장' },
          {
            id: 'subTotal',
            name: '소계',
          },
        ],
      },
      {
        id: '1-2',
        name: '전략사업2팀',
        rowSpan: 4,
        children: [
          { id: '1-2-1', name: '최광수 이사' },
          { id: '1-2-2', name: '조행래 전무' },
          { id: '1-2-3', name: '박재욱 차장' },
          {
            id: 'subTotal',
            name: '소계',
          },
        ],
      },
      {
        id: '1-3',
        name: '전략사업3팀',
        rowSpan: 2,
        children: [
          { id: '1-3-1', name: '심혁 이사' },
          {
            id: 'subTotal',
            name: '소계',
          },
        ],
      },
    ],
  },
  {
    id: '2',
    name: 'SI사업본부',
    rowSpan: 2,
    children: [
      {
        id: '2-1',
        name: 'SI사업본부 본부총괄',
        rowSpan: 2,
        children: [
          { id: '2-1-1', name: '이창준 이사' },
          {
            id: 'subTotal',
            name: '소계',
          },
        ],
      },
    ],
  },

  {
    id: 'total',
    name: '합계',
    rowSpan: 1,
    children: [
      {
        id: 'total',
        name: '합계',
        rowSpan: 1,
        children: [{ id: 'total', name: '합계' }],
      },
    ],
  },
];

export const itemsData = [
  { id: 1, itemNm: '안랩' },
  { id: 2, itemNm: 'EG이노베이선스' },
  { id: 3, itemNm: 'EDB' },
  { id: 4, itemNm: '파이오링크' },
  { id: 5, itemNm: '넷맨' },
  { id: 6, itemNm: '아리스타' },
  { id: 7, itemNm: '시큐레이어' },
  { id: 8, itemNm: '솔루피아' },
  { id: 9, itemNm: 'SQI소프트' },
  { id: 10, itemNm: 'ALE' },
];

export const partnersData = [
  { id: 1, partnerNm: '평택시청' },
  { id: 2, partnerNm: '한국장애인고용공단' },
  { id: 3, partnerNm: '서경대학교' },
  { id: 4, partnerNm: '법제처' },
  { id: 5, partnerNm: '코스맥스' },
  { id: 6, partnerNm: '서울시도시기반시설본부' },
  { id: 7, partnerNm: '농협정보시스템' },
  { id: 8, partnerNm: '한국통신사업자연합회' },
  { id: 9, partnerNm: '농협은행' },
  { id: 10, partnerNm: '한국야금' },
];

//본부
export const makeGroupsAccData = () => {
  hqData.map((hq) => {
    return groupsTopHeaders.map((top) => {
      let priceData;
      if (top.id === 'SG') {
        priceData = {
          sales: `${Math.floor(Math.random() * 1000000000)}`, //매출액
          profitPrice: `${Math.floor(Math.random() * 1000000000)}`, //매출이익,
          salesPrice: `${Math.floor(Math.random() * 1000000000)}`,
        };
      } else if (top.id === 'TG') {
        priceData = {
          sales: `${Math.floor(Math.random() * 1000000000)}`, //매출액
          purchase: `${Math.floor(Math.random() * 1000000000)}`, //매출이익,
          profitPrice: `${Math.floor(Math.random() * 1000000000)}`,
        };
      } else if (top.id === 'CP') {
        priceData = {
          cp: `${Math.floor(Math.random() * 1000000000)}`, //매출액
          cc: `${Math.floor(Math.random() * 1000000000)}`, //매출이익,
        };
      } else {
        priceData = { [top?.val]: `${Math.floor(Math.random() * 1000000000)}` };
      }

      hq[top.val] = priceData;
    });
  });
  return Array.from(hqData);
};

// 팀
export const makeGroupsAccTeamData = () => {
  teamData.map((hq) => {
    return hq.children.map((team) => {
      return groupsTopHeaders.map((top) => {
        let priceData;
        if (top.id === 'SG') {
          priceData = {
            sales: `${Math.floor(Math.random() * 1000000000)}`, //매출액
            profitPrice: `${Math.floor(Math.random() * 1000000000)}`, //매출이익,
            salesPrice: `${Math.floor(Math.random() * 1000000000)}`,
          };
        } else if (top.id === 'TG') {
          priceData = {
            sales: `${Math.floor(Math.random() * 1000000000)}`, //매출액
            purchase: `${Math.floor(Math.random() * 1000000000)}`, //매출이익,
            profitPrice: `${Math.floor(Math.random() * 1000000000)}`,
          };
        } else if (top.id === 'CP') {
          priceData = {
            cp: `${Math.floor(Math.random() * 1000000000)}`, //매출액
            cc: `${Math.floor(Math.random() * 1000000000)}`, //매출이익,
          };
        } else {
          priceData = {
            [top?.val]: `${Math.floor(Math.random() * 1000000000)}`,
          };
        }

        team[top.val] = priceData;
      });
    });
  });
  return Array.from(teamData);
};

export const makeAccEmpData = () => {
  teamEmpData.map((hq) => {
    return hq.children.map((team) => {
      return team.children.map((emp) => {
        return groupsTopHeaders.map((top) => {
          let priceData;
          if (top.id === 'SG') {
            priceData = {
              sales: `${Math.floor(Math.random() * 1000000000)}`, //매출액
              profitPrice: `${Math.floor(Math.random() * 1000000000)}`, //매출이익,
              salesPrice: `${Math.floor(Math.random() * 1000000000)}`,
            };
          } else if (top.id === 'TG') {
            priceData = {
              sales: `${Math.floor(Math.random() * 1000000000)}`, //매출액
              purchase: `${Math.floor(Math.random() * 1000000000)}`, //매출이익,
              profitPrice: `${Math.floor(Math.random() * 1000000000)}`,
            };
          } else if (top.id === 'CP') {
            priceData = {
              cp: `${Math.floor(Math.random() * 1000000000)}`, //매출액
              cc: `${Math.floor(Math.random() * 1000000000)}`, //매출이익,
            };
          } else {
            priceData = {
              [top?.val]: `${Math.floor(Math.random() * 1000000000)}`,
            };
          }

          emp[top.val] = priceData;
        });
      });
    });
  });
  return Array.from(teamEmpData);
};

//purchase performance : 매입계산서 실적 , tp => tax performance => 세금계산서 실적
export const makeItemsAccountData = () => {
  itemsData.map((item) => {
    const priceData = {
      sales: `${Math.floor(Math.random() * 1000000000)}`, //매출액
      profitPrice: `${Math.floor(Math.random() * 1000000000)}`, //매출이익,
      purchaseCost: `${Math.floor(Math.random() * 1000000000)}`, //매입원가
    };
    item.pp = priceData;
  });
  return Array.from(itemsData);
};

export const makePartnersAccountData = () => {
  partnersData.map((partner) => {
    const priceData = {
      sales: `${Math.floor(Math.random() * 1000000000)}`, //매출액
      profitPrice: `${Math.floor(Math.random() * 1000000000)}`, //매출이익,
      purchaseCost: `${Math.floor(Math.random() * 1000000000)}`, //매입원가
    };
    partner.tp = priceData;
  });
  return Array.from(partnersData);
};
